<ng-container *ngIf="!showProgressBar else progressBar">
    <form *ngIf="!isLoading else loadingView">
        <acabim-card
            [cardContent]="mainForm"
            [isCollapsible]="true"
            [isCollapsed]="false"
            [hasHelpButton]="true"
            helpMessage = 'You may change the project name and description here.'
            cardHeading="Project details"></acabim-card>
        <acabim-card
            [cardContent]="buildingForm"
            [isCollapsible]="true"
            [isCollapsed]="true"
            [hasHelpButton]="true"
            [helpMessage]="'The building 3D model can be viewed here, if available. To upload a BIM model for the project, go to Manage BIM. See the link below'"
            [intLinkUrl]="'/admin/bim/bim-model-management'"
            [linkText]="'Manage BIM Model'"
            cardHeading="Building"></acabim-card>
        <acabim-card
            [cardContent]="groupsForm"
            [isCollapsible]="true"
            [isCollapsed]="true"
            [hasHelpButton]="true"
            helpMessage = 'You may group multiple projects together to allow reporting on the group.'
            cardHeading="Project grouping"></acabim-card>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button class="cas-button" (click)="showTransferPhaseModel = true" >Change Project Phase</button>
            <button class="cas-button-action cas-button-right" (click)="updateProject()" >Update</button>
        </div>
    </form>
</ng-container>

<ng-template #progressBar>
    <p-progressBar *ngIf="!isLoading else loadingView" [value]="uploadProgress"></p-progressBar>
</ng-template>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<acabim-modal
    [display]="displayWarning"
    dontClose="true"
    [title]="'Message'"
    noPadding="true">
    <acabim-data-display [dataMap]="errorMessage"></acabim-data-display>
    <div class="cas-action-buttons">
        <button class="cas-button-action" (click)="closeErrorDialog()">OK</button>
    </div>
</acabim-modal>

<p-toast position="center" key="projectMessage"></p-toast>

<p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
    key="confirmAttachment"
    acceptButtonStyleClass="cas-button-action"></p-confirmDialog>

<ng-template #attachment>
    <div class="cas-pad">
        <acabim-multifile-upload
            #fileComp
            [mimeTypes]="mimetypes"
            (fileAdded)="onImageFileAdded($event)"
            (fileDeleted)="onFileDeleted($event)"
            (fileLoading)="onFileLoading($event)"
            [fullFiles]="fullFiles" [hasDelete]="true"></acabim-multifile-upload>
        <div class="cas-action-buttons">
            <button class="cas-button-action" type="button" (click)="addToBuilding()" [disabled]="disableAdd">Add</button>
        </div>
    </div>
</ng-template>

<ng-template #mainForm>
    <acabim-form-block
            [formGroup]="editProjectForm"
            labelWidth="10"
            [labelAlign]="'right'"
            [colonize]="true">
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Project Name</acabim-form-input-label>
            <acabim-form-input-content [mediumField]="true"  note="{{this.selectedProject?.id}}">
                <input type="text" formControlName="projectName" id="project_name">
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Description</acabim-form-input-label>
            <acabim-form-input-content>
                <input type="text" formControlName="projectDescription" id="project_description">
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
    </acabim-form-block>
</ng-template>

<ng-template #buildingForm>
    <ng-container *ngIf="_currentProject && _currentProject.buildingGuid && _currentProject.buildingStatus === 'BuildingAvailable'">
        <acabim-bim-visualiser-threed-viewer [projectId]="_currentProject?.id"></acabim-bim-visualiser-threed-viewer>
    </ng-container>
    <ng-container *ngIf="_currentProject && _currentProject.buildingStatus === 'BuildingPending'">
        <p>Building Pending</p>
    </ng-container>
    <div class="cas-pad" [formGroup]="editProjectForm">
        <acabim-card [cardContent]="attachment" cardHeading="Attachments"></acabim-card>
    </div>
</ng-template>

<ng-template #groupsForm>
    <acabim-form-block
        labelWidth="10"
        [labelAlign]="'right'"
        [formGroup]="editProjectForm"
        [colonize]="true">
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Groups</acabim-form-input-label>
            <acabim-form-input-content>
                <p-multiSelect
                    [options]="items"
                    formControlName="projectGroups"
                    defaultLabel="Select items"
                    [showHeader]="false"></p-multiSelect>
                <ng-container *ngIf="groupNames.length > 0">
                    —&nbsp;&nbsp;<small>{{groupNames.join(', ')}}</small>
                </ng-container>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
    </acabim-form-block>
</ng-template>

<acabim-modal
    title="Transfer Phase"
    [display]="showTransferPhaseModel"
    (status)="onCloseUpdatePhase($event)"
    width="80vw"
    fixHeight="80vh">
    <acabim-admin-transfer-project-phase
       [project]="this.selectedProject"
       [editForm]="editProjectForm"
       (projectPhaseTransferred)="onProjectPhaseUpdated()"></acabim-admin-transfer-project-phase>
</acabim-modal>
